/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica, DocumentoOpera,
    Manutenzione,
    Monitoraggio,
    Opera,
    OperaSecondaria,
    PianoInterventi,
    Rilevamento
} from '@models';
import { OperaService } from '@shared/services/opera.service';
import { PermessiService } from '@shared/services/permessi.service';
import { UtilsService } from '@shared/services/utils.service';
import { MonitoraggiSopralluoghi } from 'src/app/_models/domain/monitoraggi-sopralluoghi';

@Component({
    selector: 'app-pages-gestione-opera-modifica-opera',
    templateUrl: './modifica-opera.component.html',
})
export class PagesGestioneOperaModificaOperaComponent implements OnInit {
    
    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public documentoOperaList: DocumentoOpera[] = [];
    public operaSecondariaList: OperaSecondaria[] = [];
    public rilevamentoOperaList: Rilevamento[] = [];
    public manutenzioneOperaList: Manutenzione[] = [];
    public monitoraggioOperaList: Monitoraggio[] = [];
    public monitoraggiSopralluoghiList: MonitoraggiSopralluoghi[] = [];
    public pianoInterventiOperaList: PianoInterventi[] = [];
    public opera: Opera;

    constructor(
        public operaService: OperaService,
        public permessiService: PermessiService,
        private route: ActivatedRoute,
        private utilsService: UtilsService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.opera = this.operaService.operaSession;
        this.criteriaForm = this.operaService.generateFormOpera(this.opera);
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.documentoOperaList = this.route.snapshot.data['additionalInformation'].documentoOpera;
        this.pianoInterventiOperaList = this.route.snapshot.data['additionalInformation'].pianoInterventi;
        this.operaSecondariaList = this.route.snapshot.data['additionalInformation'].operaSecondaria;
        this.rilevamentoOperaList = this.route.snapshot.data['additionalInformation'].rilevamentoOpera;
        this.monitoraggioOperaList = this.route.snapshot.data['additionalInformation'].monitoraggioOpera;
        this.manutenzioneOperaList = this.route.snapshot.data['additionalInformation'].manutenzioneOpera;
        this.monitoraggiSopralluoghiList = this.route.snapshot.data['additionalInformation'].monitoraggiSopralluoghi;
        this.operaService.setRequiredValidators(this.criteriaForm);
    }

    public updateOpera() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        } else if(this.criteriaForm.get('annoFineEsistenza')?.invalid) {
            this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099');
            return;
        }
        this.operaService.update(this.criteriaForm.getRawValue()).subscribe({
            next: () => {
                this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                this.router.navigate(['..'], { relativeTo: this.route });
            },
            error: () => this.utilsService.showError('Errore durante il salvataggio')
        });
    }

    refreshOpera(refresh: boolean) {
        if(refresh) {
            this.operaService.read(this.operaService.operaSession.idOpera).subscribe((opera: Opera) => {
                this.criteriaForm.patchValue(opera);
                this.utilsService.showSuccess('L\'anagrafica dell\'opera è stata aggiornata correttamente.');
            });
        }
    }

}
